import React, { useEffect, useState } from 'react';
import { createStructuredSelector } from 'reselect';
import { useDispatch, useSelector } from 'react-redux';
import { SF_COVER_CATEGORIES, RELATIONS } from '@om/redux/actions/sizotsaFuneralCover/types';

import {
    OmFormInputFieldWrapper,
    OmSlider,
    OmLoader,
    OmSideDrawer,
    OmEfpAddCoverDrawer,
    OmButton,
    OmFormDropdownFieldWrapper,
    OmApplicationPopupModal,
    OmRadioButtonGroup,
} from '@om/component-library-react';

import { DEFAULT_VALIDATION_DELAY } from '../../../config';
import {
    getBenefitsDetails,
    getCoverType,
    getEditQuoteDetails,
    getHighestCoverAmount,
    getIsOldExtendedMemberAdded,
    getLivesCovered,
    getMonthlyPremiumQuote,
    getQuoteForm,
    getValueWithThousandSeperator,
} from '@om/redux/selectors/sizotsaFuneralCover/quote';
import {
    addToQuote,
    editQuote,
    setQuoteDetailsStateValue,
    setQuoteDetailsValue,
    setQuoteDrawerValue,
    synchOtherMembersPremium,
    updatePremiumPaidupOndobEdit,
} from '@om/redux/actions/sizotsaFuneralCover/quote';
import { FIELD_STATUS, FORM_STATUS } from '@om/redux/reducers/status';
import { getQuoteRefernceData } from '@om/redux/selectors/sizotsaFuneralCover/referenceData';

const FormContent = () => {
    const {
        coverType,
        formFields,
        calculatedQuotePremium,
        referenceData,
        livesCovered,
        highestCoverAmount,
        editQuoteDetails,
        benefits,
        isOldMemberAdded
    } = useSelector(
        createStructuredSelector({
            coverType: getCoverType,
            formFields: getQuoteForm,
            calculatedQuotePremium: getMonthlyPremiumQuote,
            referenceData: getQuoteRefernceData,
            livesCovered: getLivesCovered,
            highestCoverAmount: getHighestCoverAmount,
            editQuoteDetails: getEditQuoteDetails,
            benefits:getBenefitsDetails,
            isOldMemberAdded: getIsOldExtendedMemberAdded,
        })
    );
    const { referenceHearAboutUs, referenceOnlinePlatform, genderReferenceData ,yesNoReferenceData} = referenceData;
    const platFormLabel = {
        online: 'Online Platform',
        onRadio: 'Radio Platform',
        onTv: 'Name of Platform',
        fromBillboard: 'Name of Billboard',
        fromSomeone: 'Please enter name of referrer',
        omEmployee: 'Please enter name of referrer',
        broker: 'Please enter name of referrer',
        other: 'Please enter name of referrer',
    };
    const {
        age,
        dateOfBirth,
        gender,
        coverAmount,
        monthlyPremium,
        hearAboutUs,
        hearAboutUsPlatform,
        socialPlatform,
        referFriendFamily,
        referFullName,
        referCellphoneNumber,
        needIncomeStabilization,
        incomeStabilization
    } = formFields;
    const dispatch = useDispatch();
    const [coverAmountWarning, setCoverAmountWarning] = useState(false);
    const [warningAgeModelMyself, setWarningAgeModelMyself] = useState(false);
    const [incomeStabilizationToBeSyncedMyself, setIncomeStabilizationToBeSyncedMyself] = useState(false);
    const actionHandler = (fieldType, value, displayValue = null) => {
        dispatch(setQuoteDetailsValue({ fieldType, value, displayValue }));
    };
    useEffect(() => {
        coverType === SF_COVER_CATEGORIES.MYSELF && actionHandler('monthlyPremium', calculatedQuotePremium);
    }, [calculatedQuotePremium]);
    useEffect(() => {
        if (!coverAmount.value && coverType === SF_COVER_CATEGORIES.MYSELF) {
            actionHandler('coverAmount', 10000);
            actionHandler('selectedCoverCategory', SF_COVER_CATEGORIES.MYSELF);
        }
        setIncomeStabilizationToBeSyncedMyself(false)
        coverType === SF_COVER_CATEGORIES.MYSELF && !incomeStabilization.value && actionHandler('incomeStabilization', 1000);
    }, [coverType]);

    const handleAddtoQuote = () => {
        dispatch(addToQuote({ coverType: SF_COVER_CATEGORIES.ME_AND_MY_DIRECT_FAMILY, relation: RELATIONS.MYSELF }));
    };
    // useEffect(()=>{
    //     if(age?.value>49 && benefits?.benefitsDetailsOnPremium?.value === 'Yes'){
    //         setWarningAgeModelMyself(true)
    //     } else {
    //         setWarningAgeModelMyself(false)
    //     }
    // },[age])
    const handleClose=() => {        
        setIncomeStabilizationToBeSyncedMyself(false)
        dispatch(setQuoteDrawerValue({ fieldType: 'coverType', value: null }));
        dispatch(
            setQuoteDetailsStateValue({
                fieldType: 'editQuoteDetails',
                value: { id: null, category: null },
            })
        );
        // dispatch(setSideDrawerClosed());
    }
     useEffect(() => {
          actionHandler('incomeStabilization', 1000)
        },[coverAmount.value])  
        
            const getSlider=() => {
            if (+coverAmount.value < 30000) return <OmSlider
                                                    key="incomeStabilization"
                                                    id="incomeStabilization1000"
                                                    stepString={JSON.stringify([1000])}
                                                    minLabel={`E 1000`}
                                                    maxLabel={`E 1000`}
                                                    value={incomeStabilization?.value ?? 1000}
                                                    valuePrefix={'E'}
                                                    onSliderChange={(event) =>
                                                        actionHandler('incomeStabilization', event.detail)
                                                    }
                                                /> 
            if (+coverAmount.value < 50000) return <OmSlider
                                                    key="incomeStabilization1500"
                                                    id="incomeStabilization1500"
                                                    stepString={JSON.stringify([1000, 1500])}
                                                    minLabel={`E 1000`}
                                                    maxLabel={`E 1500`}
                                                    value={incomeStabilization?.value ?? 1000}
                                                    valuePrefix={'E'}
                                                    onSliderChange={(event) =>
                                                        actionHandler('incomeStabilization', event.detail)
                                                    }
                                                /> 
            else return <OmSlider
                                                    key="incomeStabilization2000"
                                                    id="incomeStabilization2000"
                                                    stepString={JSON.stringify([1000, 1500,2000])}
                                                    minLabel={`E 1000`}
                                                    maxLabel={`E 2000`}
                                                    value={incomeStabilization?.value ?? 1000}
                                                    valuePrefix={'E'}
                                                    onSliderChange={(event) =>
                                                        actionHandler('incomeStabilization', event.detail)
                                                    }
                                                /> ;
        }
    return (
        <>
            <OmSideDrawer
                open={coverType === SF_COVER_CATEGORIES.MYSELF && !coverAmountWarning && !warningAgeModelMyself}
                onOnSideDrawerClosed={() =>handleClose()   // dispatch(setSideDrawerClosed());
                }
            >
                <div slot="side-drawer-content">
                    <OmEfpAddCoverDrawer>
                        <div className="progressive-disclosure-form-wrapper">
                            <h5 className="no-top-margin no-bottom-margin medium">Myself</h5>
                            <OmFormInputFieldWrapper
                                isSensitive
                                required
                                labelAlwaysShow
                                hintText={'Format : dd/mm/yyyy'}
                                name="dateOfBirth"
                                size="full"
                                align="left"
                                mask="date"
                                placeholder="DD/MM/YYYY"
                                label="Date of birth*"
                                validationDelay={DEFAULT_VALIDATION_DELAY}
                                value={dateOfBirth?.value}
                                // state={dateOfBirth?.status}
                                errorMessage={dateOfBirth?.error || age?.error}
                                onPersist={(event) => actionHandler('dateOfBirth', event.detail)}
                            />
                            <OmFormDropdownFieldWrapper
                                align="left"
                                placeholder="Select gender*"
                                placeholderAsLabel="false"
                                formId="quoteform"
                                size="full"
                                name={`gender`}
                                useNativeMobileDropdown
                                required
                                key={'gender'}
                                value={gender?.value}
                                state={gender?.status}
                                errorMessage={gender?.error}
                                options={JSON.stringify(
                                    genderReferenceData &&
                                        genderReferenceData?.map((item) => ({
                                            value: item.code,
                                            label: item.description,
                                        }))
                                )}
                                onOnSelect={(event) => {
                                    actionHandler('gender', event.detail.value, event.detail.id);
                                }}
                            />
                            {dateOfBirth?.status === FIELD_STATUS.VALID && !coverAmountWarning && (
                                <>
                                    <h6 className="no-bottom-margin om-form-input-field-wrapper theme-default medium-margin-top">
                                        <strong>Select cover amount:</strong>
                                    </h6>
                                    <OmSlider
                                        stepString={JSON.stringify([10000, 20000, 40000, 50000, 60000, 80000])}
                                        minLabel={'E10000'}
                                        maxLabel={'E80000'}
                                        value={coverAmount?.value ?? 10000}
                                        valuePrefix={'E'}
                                        onSliderChange={
                                            (event) => {
                                               
                                                // if (
                                                //     coverType=== SF_COVER_CATEGORIES.MYSELF&&
                                                //     !incomeStabilizationToBeSyncedMyself &&
                                                //     event.detail < 20000 &&
                                                //     benefits?.incomeStabilization?.value
                                                // ) {
                                                //     setWarningAgeModelMyself(true);
                                                // }

                                                actionHandler('coverAmount', event.detail);
                                                event.detail<20000 && needIncomeStabilization.value && actionHandler('needIncomeStabilization','No')
                                                
                                            }
                                        }
                                    />
                                    {coverAmount.value>=20000 && <>  <h6 className="no-margin">
                                        <strong>Would you like to include Income Stabilization?</strong>
                                    </h6>
                                    <OmFormDropdownFieldWrapper
                                        align="left"
                                        placeholder="Select an option*"
                                        placeholderAsLabel="false"
                                        formId="quoteform"
                                        size="full"
                                        name={`gender`}
                                        useNativeMobileDropdown
                                        required
                                        key={'gender'}
                                        value={needIncomeStabilization?.value}
                                        state={needIncomeStabilization?.status}
                                        errorMessage={needIncomeStabilization?.error}
                                        options={JSON.stringify(
                                            yesNoReferenceData &&
                                                yesNoReferenceData?.map((item) => ({
                                                    value: item.code,
                                                    label: item.description,
                                                }))
                                        )}
                                        onOnSelect={(event) => {
                                            actionHandler(
                                                'needIncomeStabilization',
                                                event.detail.value,
                                                event.detail.id
                                            );
                                        }}
                                    /></>}
                                    {needIncomeStabilization.value === 'Yes' && (
                                        <>
                                            <p className="inline-group">
                                                <span className="mobile-line-break no-top-margin small">
                                                    If you have a cover of E20,000 or more, you can receive E1,000,
                                                    E1,500, or E2,000 per month for 6 consecutive months after your
                                                    claim is processed.
                                                </span>
                                            </p>
                                          {getSlider()}
                                        </>
                                    )}
                                    <div
                                        className="cover-label-wrapper medium-margin-top"
                                        style={{ flexWrap: 'wrap' }}
                                    >
                                        <span className="cover-label" style={{  }}>
                                            <h5 className="no-bottom-margin no-top-margin medium">
                                                E {getValueWithThousandSeperator(coverAmount?.value)}
                                            </h5>
                                            <p className="small medium no-top-margin">Cover Amount</p>
                                        </span>

                                        <span className="cover-label" style={{textAlign:'right'}}>
                                            <h5 className="no-bottom-margin no-top-margin medium">
                                                E {monthlyPremium?.value?.toFixed(2) ?? 0} PM / E {getValueWithThousandSeperator((+monthlyPremium?.value * 12)?.toFixed(2))} PA
                                            </h5>
                                            <p className="small medium no-top-margin base-margin-bottom">
                                                Total Premium
                                            </p>

                                            {/* <h5 className="no-bottom-margin no-top-margin medium">
                                                E {getValueWithThousandSeperator((+monthlyPremium?.value * 12)?.toFixed(2))}
                                            </h5>
                                            <h6 className="small medium no-top-margin">ANNUALLY PREMIUM</h6> */}
                                        </span>
                                        {/* <span className="cover-label"  style={{width: '50%', marginLeft: 'auto'}}>
                                           
                                        </span> */}
                                    </div>
                                </>
                            )}{' '}
                            {/* <h5
                                className="medium-margin-top"
                                style={{
                                    fontWeight: '500',
                                    color: '#747474',
                                    fontSize: '22px',
                                    lineHeight: '26px',
                                }}
                            >
                                Referral
                            </h5> */}
                            <br></br>
                            <div slot="modal-content">
                                <span className="no-margin-top">How did you hear about the Sizotsa Funeral Cover?*
                                </span>
                                <OmFormDropdownFieldWrapper
                                    align="left"
                                    placeholder="Please select"
                                    placeholderAsLabel="false"
                                    formId="addInLaws"
                                    size="full"
                                    name={`hearAboutUs`}
                                    useNativeMobileDropdown
                                    required
                                    key={'hearAboutUs'}
                                    value={hearAboutUs?.value}
                                    state={hearAboutUs?.status}
                                    errorMessage={hearAboutUs?.error}
                                    options={JSON.stringify(
                                        referenceHearAboutUs &&
                                            referenceHearAboutUs?.map((item) => ({
                                                value: item.code,
                                                label: item.description,
                                            }))
                                    )}
                                    onOnSelect={(event) => {
                                        actionHandler('hearAboutUs', event.detail.value, event.detail.id);
                                    }}
                                />
                                {['omEmployee', 'broker'].includes(
                                    hearAboutUs?.displayValue
                                ) && (
                                    <>
                                        <OmFormInputFieldWrapper
                                            isSensitive
                                            required
                                            name="hearAboutUsPlatform"
                                            size="full"
                                            align="left"
                                            placeholder={platFormLabel[hearAboutUs?.displayValue]+' (Optional)'}
                                            validationDelay={DEFAULT_VALIDATION_DELAY}
                                            value={hearAboutUsPlatform?.value}
                                            state={hearAboutUsPlatform?.status}
                                            errorMessage={hearAboutUsPlatform?.error}
                                            onPersist={(event) => actionHandler('hearAboutUsPlatform', event.detail)}
                                        />
                                    </>
                                )}
                                <br></br>
                                {hearAboutUs?.displayValue === 'online' && (
                                    <>
                                        <OmFormDropdownFieldWrapper
                                            align="left"
                                            placeholder="Please select "
                                            placeholderAsLabel="false"
                                            formId="socialPlatform"
                                            size="full"
                                            name={`socialPlatform`}
                                            useNativeMobileDropdown
                                            required
                                            key={'socialPlatform'}
                                            value={socialPlatform?.value}
                                            state={socialPlatform?.status}
                                            errorMessage={socialPlatform?.error}
                                            options={JSON.stringify(
                                                referenceOnlinePlatform &&
                                                    referenceOnlinePlatform?.map((item) => ({
                                                        value: item.code,
                                                        label: item.description,
                                                    }))
                                            )}
                                            onOnSelect={(event) => {
                                                actionHandler('socialPlatform', event.detail.value, event.detail.id);
                                            }}
                                        />
                                    </>
                                )}
                                <br></br>
                                {/* <p className="heading margin-top-medium">
                                    <>
                                        Is there someone among your friends or family who could also benefit from our
                                        trusted service?
                                    </>
                                </p>
                                <OmRadioButtonGroup
                                    vertical="true"
                                    groupName="referFriends"
                                    value={referFriendFamily?.value}
                                    onOnSelection={(event) => {
                                        actionHandler('referFriendFamily', event.detail);
                                        
                                    }}
                                >
                                    <ul>
                                        <li value={'Yes'}>Yes</li>
                                        <li value={'No'}>No</li>
                                    </ul>
                                </OmRadioButtonGroup>
                                {referFriendFamily?.value === 'Yes' && (
                                    <>
                                        <OmFormInputFieldWrapper
                                            required={true}
                                            size="full"
                                            formId="allsureInsurancePersonalDetailsForm"
                                            align="left"
                                            validationDelay={DEFAULT_VALIDATION_DELAY}
                                            isSensitive
                                            id="referFullName"
                                            name="referFullName"
                                            placeholder="Full name"
                                            value={referFullName.value}
                                            state={referFullName.status}
                                            errorMessage={referFullName?.error}
                                            onPersist={({ detail }) => actionHandler('referFullName', detail)}
                                        />

                                        <OmFormInputFieldWrapper
                                            required={true}
                                            size="full"
                                            formId="allsureInsurancePersonalDetailsForm"
                                            align="left"
                                            validationDelay={DEFAULT_VALIDATION_DELAY}
                                            isSensitive
                                            id="referCellphoneNumber"
                                            placeholder="Cellphone number"
                                            name="cellphoneNumber"
                                            value={referCellphoneNumber?.value}
                                            state={referCellphoneNumber?.status}
                                            errorMessage={referCellphoneNumber?.error}
                                            onPersist={({ detail }) => actionHandler('referCellphoneNumber', detail)}
                                        />
                                    </>
                                )} */}
                            </div>
                            <div className="action-buttons">
                                {editQuoteDetails.id ? (
                                    <OmButton
                                        type="text"
                                        size="small"
                                        text="CANCEL"
                                        onClick={() => {
                                            dispatch(setQuoteDrawerValue({ fieldType: 'coverType', value: null }));
                                            dispatch(
                                                setQuoteDetailsStateValue({
                                                    fieldType: 'editQuoteDetails',
                                                    value: { id: null, category: null },
                                                })
                                            );
                                        }}
                                    />
                                ) : (
                                    <OmButton
                                        type="text"
                                        size="small"
                                        text="CLEAR ALL"
                                        onClick={() => {
                                            dispatch(
                                                setQuoteDrawerValue({
                                                    fieldType: 'coverType',
                                                    value: SF_COVER_CATEGORIES.MYSELF,
                                                })
                                            );
                                            actionHandler('coverAmount', 5000);
                                        }}
                                    />
                                )}
                                <OmButton
                                    type="primary"
                                    size="small"
                                    text={'ADD TO QUOTE'}
                                    onClick={() => {
                                        if (isOldMemberAdded) {
                                            setCoverAmountWarning(true);
                                        } else {
                                            handleAddtoQuote();
                                        }
                                    }}
                                />
                            </div>
                        </div>
                    </OmEfpAddCoverDrawer>
                </div>
            </OmSideDrawer>
            <OmApplicationPopupModal
                dismissible={false}
                exitable={false}
                open={coverAmountWarning}
                // isOverlay
                onModalClosed={() => {
                    setCoverAmountWarning(false);
                }}
                name="coverAmountWarning"
            >
                <div slot="content">
                    <p>
                        Lowering the cover may impact the cover amount limit for other member, are you sure you still
                        want to proceed{' '}
                    </p>
                </div>
                <div style={{ display: 'flex', justifyContent: 'center' }} slot="button">
                    <OmButton
                        type="primary"
                        size="small"
                        text="Yes, Please"
                        onClick={() => {
                            dispatch(synchOtherMembersPremium());
                            handleAddtoQuote();
                            handleClose()
                        }}
                    />
                    <OmButton
                        type="secondary"
                        size="small"
                        text="No, thanks"
                        onClick={() => {
                            setCoverAmountWarning(false);
                            handleClose()
                            setTimeout(()=>{
                                dispatch(
                                    editQuote({
                                        id: Object.keys(livesCovered[SF_COVER_CATEGORIES.ME_AND_MY_DIRECT_FAMILY])[0],
                                        category: SF_COVER_CATEGORIES.ME_AND_MY_DIRECT_FAMILY,
                                        coverType: SF_COVER_CATEGORIES.MYSELF,
                                    })
                                );
                            },10)
                        }}
                    />
                </div>
            </OmApplicationPopupModal>
            <OmApplicationPopupModal
                dismissible={false}
                exitable={false}
                open={warningAgeModelMyself}
                // isOverlay
                onModalClosed={() => {
                    setWarningAgeModelMyself(false);
                }}
                name="benifitWarning"
            >
                <div slot="content">
                    <p>
                        Changing the cover amount may impact the Income Stabilization benefit for main member, are you sure you still
                        want to proceed{' '}
                    </p>
                </div>
                <div style={{ display: 'flex', justifyContent: 'center' }} slot="button">
                    <OmButton
                        type="primary"
                        size="small"
                        text="Yes, Please"
                        onClick={() => {
                            setWarningAgeModelMyself(false)
                            setIncomeStabilizationToBeSyncedMyself(true);
                            // handleAddtoQuote();
                        }}
                    />
                    <OmButton
                        type="secondary"
                        size="small"
                        text="No, thanks"
                        onClick={() => {
                            setWarningAgeModelMyself(false)
                            handleClose()
                            setTimeout(()=>{
                                dispatch(
                                    editQuote({
                                        id: Object.keys(livesCovered[SF_COVER_CATEGORIES.ME_AND_MY_DIRECT_FAMILY])[0],
                                        category: SF_COVER_CATEGORIES.ME_AND_MY_DIRECT_FAMILY,
                                        coverType: SF_COVER_CATEGORIES.MYSELF,
                                    })
                                );
                            },10)
                           

                        }}
                    />
                </div>
            </OmApplicationPopupModal>
        </>
    );
};

const MyselfFamilyDrawer = () => {
    // if (applicationReferenceDataValid && quoteReferenceDataValid) {
    return <FormContent />;
    // }

    // return (
    //     <div>
    //         {loadingText(directFamilyDrawerOpen)}
    //     </div>
    // );
};

export default MyselfFamilyDrawer;
